/*
 * @Author: ITDLCL
 * @Date: 2025-03-26 14:06:25
 * @LastEditors: ITDLCL
 * @Description:
 */
import { showToast } from "vant";
import { nanoid } from "nanoid";

/**
 * @description: 复制文本
 * @param {type}
 */
export function copyTextFun (
  copyText = null,
  successMessage = "复制成功",
  hasHandleLink = true
) {
  if (copyText == null) return false;
  const textString = copyText.toString();
  // 修改判断转化分享链接
  if (/http/gm.test(textString) && hasHandleLink) {
    // textString = handleLink(textString);
  }
  let input = document.querySelector("#createCopyInput");
  if (!input) {
    input = document.createElement("input");
    input.id = "createCopyInput";
    input.readOnly = "readOnly"; // 防止ios聚焦触发键盘事件
    input.style.position = "fixed";
    input.style.left = "0";
    input.style.zIndex = "-1";
    document.body.appendChild(input);
  }

  input.value = textString;
  // ios必须先选中文字且不支持 input.select();
  selectText(input, 0, textString.length);
  if (document.execCommand("copy")) {
    document.execCommand("copy");
    showToast(successMessage);
  }
  input.blur();
}

// input自带的select()方法在苹果端无法进行选择，所以需要自己去写一个类似的方法
// 选择文本。createTextRange(setSelectionRange)是input方法
export function selectText (textbox, startIndex, stopIndex) {
  if (textbox.createTextRange) {
    // ie
    const range = textbox.createTextRange();
    range.collapse(true);
    range.moveStart("character", startIndex); // 起始光标
    range.moveEnd("character", stopIndex - startIndex); // 结束光标
    range.select(); // 不兼容苹果
  } else {
    // firefox/chrome
    textbox.setSelectionRange(startIndex, stopIndex);
    textbox.focus();
  }
}

export function setDeviceInfo () {
  return new Promise((resolve) => {
    const id = nanoid();
    window.localStorage.setItem("deviceId", id);
  });
};
